module.exports = __webpack_public_path__ + "img/stepsBg.3a92def5.png";